"use client";

import styled from "styled-components";
import Button from "../button";
import { Input } from "../form";

export const BoxSelectGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SelectDate = styled(Input)`
  border-radius: 0;
  background: var(--backgroundColorCard);
  min-width: 160px;
  text-align: center;
`;

export const ButtonsPagination = styled(Button)`
  &:first-child {
    border-radius: calc(0.625rem - 2px) 0 0 calc(0.625rem - 2px);
  }
  &:last-child {
    border-radius: 0 calc(0.625rem - 2px) calc(0.625rem - 2px) 0;
  }
`;
